export default __webpack_public_path__ + "static/media/womanNoMark.53f45965.jpeg";